export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <p className="text-sm font-medium text-primary-600">关于我们 · ABOUT</p>
            <h2 className="mt-1 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              关于全网爆闻站
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              全网爆闻站是一站式的大V爆料源聚合平台。我们持续整理微博认证用户与百万粉红人公开发布的争议内容与圈内动向，把散落在各处的「信息来源」按热度与领域归拢到一起。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              与其说我们在生产热点，不如说我们在搭建一张「信息来源地图」——让你不用一个个账号去翻，也能快速定位到该领域的核心爆料人与一手动态。
            </p>

            <div className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {[
                { n: "1200+", l: "聚合账号" },
                { n: "3000+", l: "话题事件" },
                { n: "6 大", l: "垂直领域" },
                { n: "5min", l: "热榜刷新" },
              ].map((s) => (
                <div key={s.l} className="rounded-xl border border-background-200/70 bg-background-100/60 p-4 text-center">
                  <p className="font-heading text-2xl font-bold text-primary-600">{s.n}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.l}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-center gap-2 text-xs text-foreground-400">
              <i className="ri-shield-check-line text-base text-accent-600"></i>
              虚构示例数据，仅用于平台功能演示
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-2xl border border-background-200/70 bg-background-100/60 p-6">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-compass-3-line text-lg"></i>
                </span>
                内容原则
              </h3>
              <ul className="mt-4 space-y-3">
                {[
                  { i: "ri-arrow-right-up-line", t: "信息聚合，不做定性", d: "汇总公开来源的讨论与动向，不替任何事件下结论。" },
                  { i: "ri-arrow-right-up-line", t: "标注来源，鼓励溯源", d: "每条内容均标明出处，引导用户回到原始信息判断。" },
                  { i: "ri-arrow-right-up-line", t: "理性善意，守护生态", d: "倡导理性讨论，反对网络暴力和无根据的情绪化传播。" },
                ].map((p) => (
                  <li key={p.t} className="flex gap-3">
                    <i className={`${p.i} mt-0.5 text-primary-500`}></i>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{p.t}</p>
                      <p className="mt-0.5 text-sm text-foreground-500">{p.d}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-2xl border border-background-200/70 bg-background-100/60 p-6">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-chat-quote-line text-lg"></i>
                </span>
                读者口碑
              </h3>
              <div className="mt-4 space-y-4">
                {[
                  { who: "追星阿黎 · 文娱爱好者", txt: "追星十年，现在找消息第一站就是这里，分类很全，省了我不少翻首页的时间。" },
                  { who: "数码老K · 科技博主", txt: "作为圈内人，觉得他们把「爆料与求证」的边界说得很清楚，值得同行借鉴。" },
                ].map((r) => (
                  <div key={r.who} className="rounded-lg bg-background-50 p-4">
                    <p className="text-sm leading-relaxed text-foreground-600">“{r.txt}”</p>
                    <p className="mt-2 text-xs font-medium text-foreground-400">{r.who}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}